<template lang="pug">
Response(
    view="success"
    title="Оплата прошла успешно!"
    description="Квитанцию и другую информацию по платежу вы можете посмотреть в приложении банка"
    button-text="Вернуться в магазин"
    :button-href="state.merchant.link"
)
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'

import { Response } from '@/shared/ui/Response'
import { useAppStore } from '@/shared/model'

export default defineComponent({
    name: 'SuccessState',
    setup() {
        const { state } = useAppStore()

        onMounted(() => {
            setTimeout(() => {
                if (
                    state.kind === 'resolved' &&
                    state.autoRedirect &&
                    state.merchant.link
                ) {
                    window.location.href = state.merchant.link
                }
            }, 2000)
        })

        return {
            state,
        }
    },
    components: { Response },
})
</script>
